<script lang="ts" setup scoped>
import { ref } from 'vue';
import { Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

const IMAGE_OPTION = '?auto=compress,format&w=2400';
const controlledSwiper = ref(null);
const setControlledSwiper = (swiper: any) => {
  controlledSwiper.value = swiper;
};

const sildes = [`slide_01.png`, `slide_02.png`, `slide_03.png`, `slide_04.png`, `slide_05.png`].map(
  (img) => `https://dvercorp-co-kr.imgix.net/dpost/home/${img}${IMAGE_OPTION}`
);
</script>

<template>
  <div>
    <swiper
      :modules="[Pagination, Autoplay]"
      :slides-per-view="1"
      :space-between="10"
      :pagination="true"
      :autoplay="true"
    >
      <swiper-slide
        v-for="(item, index) in sildes"
        :key="item"
        class="slide"
      >
        <img
          :src="item"
          :alt="`디포스트 한 눈에 보기${index}`"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<style lang="scss" scoped>
.slide {
  @apply w-full text-center flex flex-col justify-center text-xl font-bold;

  img {
    @apply w-full rounded-[30px];
    @apply max-h-[740px];
  }
}
.sliderWrapper {
  :global(.swiper-pagination-bullet) {
    @apply w-2 h-2 rounded-full bg-white opacity-50;
  }

  :global(.swiper-pagination-bullet-active) {
    @apply bg-opacity-100 w-2.5 h-2.5 opacity-100;
  }
}
</style>
